// Sentinel written into the search `neighbourhood` param by the homepage/location-page
// "Near me" flow; the search page matches against it to clear the field on focus.
export const NEAR_ME_LABEL = 'Near me';
